module.exports = __webpack_public_path__ + "p.no1.cf9244f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/p.no1.jpg
// module id = 1kNF
// module chunks = 0